import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'created':
        return 'Plus';
      case 'updated':
        return 'Edit';
      case 'published':
        return 'CheckCircle';
      case 'unpublished':
        return 'XCircle';
      case 'deleted':
        return 'Trash2';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'created':
        return 'var(--color-accent)';
      case 'updated':
        return 'var(--color-primary)';
      case 'published':
        return 'var(--color-success)';
      case 'unpublished':
        return 'var(--color-warning)';
      case 'deleted':
        return 'var(--color-error)';
      default:
        return 'var(--color-muted-foreground)';
    }
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  };

  return (
    <div className="flex items-start gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors duration-250">
      <div 
        className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
        style={{ background: `${getActivityColor(activity?.type)}15` }}
      >
        <Icon name={getActivityIcon(activity?.type)} size={16} color={getActivityColor(activity?.type)} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-foreground mb-1">{activity?.description}</p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>{activity?.user}</span>
          <span>•</span>
          <span>{formatTime(activity?.timestamp)}</span>
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;